/**
 * KARVA Geschenk-Optionen im Konfigurator (2026-10)
 *
 * - "Als Geschenk verpacken" (Produkt /products/geschenkverpackung, 9 €, 1.11.–24.12. gratis per
 *   automatischem Rabatt) mit Textfeld für die gedruckte Grußkarte
 * - "Gravur auf der Rückseite" (Produkt /products/gravur-rueckseite, 29 €), 2 Zeilen à max. 25 Zeichen
 * - "Gravur auf der Vorderseite" (Produkt /products/gravur-vorderseite, 29 €), 2 Zeilen à max. 25 Zeichen
 * - "Express: in 24 Stunden verschickt" (Produkt /products/express-fertigung), Annahmeschluss Mo–Fr 14 Uhr,
 *   in der Weihnachtspause (18.12. 14 Uhr bis 10.01.) ausgeblendet
 *
 * - "Ihr dürft mich fragen" (freiwillig, nicht vorangehakt): setzt die Eigenschaft "Social-Media" am Bild.
 *   Nach dem Versand fragt KARVA per E-Mail konkret um Erlaubnis, bevor etwas gezeigt wird.
 *
 * Preise kommen immer live aus den Produkten. Die Optionen erscheinen nur, wenn die Produkte im
 * Onlineshop verfügbar sind. Beim Klick auf "In den Warenkorb" (Konfigurator) werden die Texte als
 * Eigenschaften gespeichert und die Zusatzprodukte direkt nach dem Bild in den Warenkorb gelegt.
 */
(function () {
  'use strict';

  var GIFT_HANDLE = 'geschenkverpackung';
  var ENGRAVE_HANDLE = 'gravur-rueckseite';
  var FRONT_HANDLE = 'gravur-vorderseite';
  var MSG_MAX = 300;
  var LINE_MAX = 25;
  var PROMO_FROM = { m: 10, d: 1 };   // 1. November (Monat 0-basiert)
  var PROMO_TO = { m: 11, d: 24 };    // 24. Dezember

  var GIFT = null;     // { id, price }
  var ENGRAVE = null;  // { id, price }
  var FRONT = null;    // { id, price }

  /* ---------- Express-Fertigung (Produkt /products/express-fertigung) ----------
   * Annahmeschluss Mo–Fr 14:00 Uhr (Europe/Berlin). Bestellung vor dem Schluss = Versand am
   * nächsten Werktag. Expressversand (DPD, Zustellung am Werktag nach Versand) wählt der Kunde im Checkout.
   * Pausieren: Produkt "Express-Fertigung" auf Entwurf stellen, dann verschwinden Box und Banner. */
  var EXPRESS_HANDLE = 'express-fertigung';
  var CUTOFF_HOUR = 14;   // bis 14 Uhr bestellt: heute fräsen + lackieren, über Nacht trocknen, morgen Versand
  var HOLIDAYS = ['2026-12-24', '2026-12-25', '2026-12-26', '2026-12-31', '2027-01-01', '2027-01-06',
                  '2027-03-26', '2027-03-29', '2027-05-01', '2027-05-06', '2027-05-17', '2027-05-27'];
  var XMAS_LAST_DELIVERY = '12-23';   // spätester Liefertag vor Weihnachten (MM-TT)
  // Weihnachtspause: letzte Bestellung Fr 18.12. 14 Uhr, nächster Fertigungstag Mo 11.01.2027.
  // In der Pause ist Express ausgeblendet; stattdessen erscheint ein Hinweis mit Link zum Gutschein.
  var BREAK_START = '2026-12-18', BREAK_START_HOUR = 14, BREAK_END = '2027-01-11';
  // Standardbestellungen (ohne Express) mit 2 Tagen Puffer: bis Mi 16.12. 14 Uhr sicher vor Weihnachten.
  var STD_XMAS_CUTOFF = '2026-12-16', STD_XMAS_CUTOFF_HOUR = 14;
  var EXPRESS = null;  // { id, price }
  var DAYS = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];

  function berlinNow() {
    var o = {};
    try {
      new Intl.DateTimeFormat('de-DE', { timeZone: 'Europe/Berlin', year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(new Date()).forEach(function (p) { o[p.type] = p.value; });
    } catch (e) {
      var n = new Date(); o = { year: n.getFullYear(), month: n.getMonth() + 1, day: n.getDate(), hour: n.getHours(), minute: n.getMinutes() };
    }
    return { date: new Date(Date.UTC(+o.year, +o.month - 1, +o.day)), h: +o.hour, m: +o.minute };
  }
  function iso(d) { return d.toISOString().slice(0, 10); }
  function addDays(d, n) { return new Date(d.getTime() + n * 864e5); }
  function isWorkday(d) { var w = d.getUTCDay(); return w > 0 && w < 6 && HOLIDAYS.indexOf(iso(d)) === -1; }
  function nextWorkday(d) { var x = addDays(d, 1); while (!isWorkday(x)) x = addDays(x, 1); return x; }
  function fmtDay(d) { return DAYS[d.getUTCDay()] + ', ' + d.getUTCDate() + '.' + (d.getUTCMonth() + 1) + '.'; }
  function afterStdCutoff() {
    var now = berlinNow(), d = iso(now.date);
    return d > STD_XMAS_CUTOFF || (d === STD_XMAS_CUTOFF && now.h >= STD_XMAS_CUTOFF_HOUR);
  }
  function inBreak() {
    var now = berlinNow(), d = iso(now.date);
    var started = d > BREAK_START || (d === BREAK_START && now.h >= BREAK_START_HOUR);
    return started && d < BREAK_END;
  }

  function expressPlan() {
    var now = berlinNow();
    var today = isWorkday(now.date) && now.h < CUTOFF_HOUR;
    var orderDay = today ? now.date : nextWorkday(now.date);
    var ship = nextWorkday(orderDay);
    var deliver = nextWorkday(ship);
    var left = today ? (CUTOFF_HOUR * 60) - (now.h * 60 + now.m) : 0;
    var y = now.date.getUTCFullYear();
    var xmasLimit = new Date(Date.UTC(y, 11, +XMAS_LAST_DELIVERY.slice(3)));
    var xmasLate = now.date.getUTCMonth() === 11 && now.date.getUTCDate() <= 26 && deliver > xmasLimit;
    return { today: today, orderDay: orderDay, ship: ship, deliver: deliver, left: left, xmasLate: xmasLate };
  }

  function expressText(short) {
    var p = expressPlan();
    var t;
    if (p.today) {
      var hh = Math.floor(p.left / 60), mm = p.left % 60;
      t = 'Noch ' + (hh ? hh + ' Std. ' : '') + mm + ' Min. bestellen: Versand am ' + fmtDay(p.ship);
    } else {
      t = 'Jetzt bestellen: Versand am ' + fmtDay(p.ship) + ' (Annahmeschluss Mo–Fr 14 Uhr)';
    }
    if (!short) t += ', mit Expressversand bei dir am ' + fmtDay(p.deliver);
    if (p.xmasLate) t += ' Lieferung vor Weihnachten ist leider nicht mehr möglich.';
    else if (afterStdCutoff() && !inBreak()) t += ' Ohne Express kommt dein Bild nicht mehr sicher vor Weihnachten an.';
    return t;
  }

  function byId(id) { return document.getElementById(id); }

  function euro(cents) {
    return (cents / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }

  function promoActive() {
    var now = new Date();
    var y = now.getFullYear();
    var from = new Date(y, PROMO_FROM.m, PROMO_FROM.d, 0, 0, 0);
    var to = new Date(y, PROMO_TO.m, PROMO_TO.d, 23, 59, 59);
    return now >= from && now <= to;
  }

  function loadProduct(handle) {
    if (typeof fetch !== 'function') return Promise.resolve(null);
    return fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.variants || !p.variants.length || !p.variants[0].available) return null;
        return { id: p.variants[0].id, price: p.variants[0].price };
      })
      .catch(function () { return null; });
  }

  function injectStyles() {
    if (byId('karva-gift-style')) return;
    var st = document.createElement('style');
    st.id = 'karva-gift-style';
    st.textContent =
      '.karva-gift__fields{display:none;margin-top:10px;}' +
      '.karva-gift.is-on .karva-gift__fields{display:block;}' +
      '.karva-gift__fields textarea,.karva-gift__fields input[type=text]{display:block;width:100%;box-sizing:border-box;margin:0 0 6px;padding:8px 10px;' +
      'border:1px solid #c9c3b8;border-radius:4px;background:#fff;font:inherit;font-size:14px;line-height:1.4;color:#202020;}' +
      '.karva-gift__fields textarea{min-height:76px;resize:vertical;}' +
      '.karva-gift__count{display:block;text-align:right;font-size:11.5px;color:#777;margin:-2px 0 6px;}' +
      '.karva-gift__hint{display:block;font-size:12.5px;color:#555;margin-top:2px;}' +
      '.karva-gift__badge{display:inline-block;margin-left:6px;padding:1px 7px;border-radius:999px;background:#DFB773;color:#202020;font-size:11.5px;font-weight:600;vertical-align:1px;}' +
      '.karva-gift__strike{text-decoration:line-through;opacity:.6;margin-right:4px;}' +
      '.halftone-right-section>.karva-express{border:2px solid #DFB773!important;background:#fbf6ec!important;}' +
      '.karva-express__when{display:block;margin-top:4px;font-size:13px;font-weight:600;color:#202020;}' +
      '.karva-express__ship{display:block;margin-top:4px;font-size:12.5px;color:#555;}';
    document.head.appendChild(st);
  }

  function stop(e) { e.stopPropagation(); }

  function counter(field, out, max) {
    function upd() { out.textContent = field.value.length + ' / ' + max; }
    field.addEventListener('input', upd);
    upd();
  }

  function buildGift() {
    var box = document.createElement('label');
    box.className = 'karva-optimize karva-gift';
    box.id = 'karva-gift-box';
    var priceHtml = promoActive()
      ? '<span class="karva-gift__strike">+' + euro(GIFT.price) + '</span>gratis<span class="karva-gift__badge">Weihnachtsangebot</span>'
      : '+' + euro(GIFT.price);
    box.innerHTML =
      '<input type="checkbox" id="karva-gift">' +
      '<span style="flex:1 1 auto;min-width:0;"><strong>Als Geschenk verpacken (' + priceHtml + ')</strong>' +
      '<small>Geschenkverpackung mit gedruckter Grußkarte. Auf Wunsch schicken wir direkt an die beschenkte Person, ohne Rechnung und Preise im Paket.</small>' +
      '<span class="karva-gift__fields">' +
        '<textarea id="karva-gift-msg" maxlength="' + MSG_MAX + '" placeholder="Dein Gruß für die Karte (optional)"></textarea>' +
        '<span class="karva-gift__count" id="karva-gift-msg-count"></span>' +
        '<span class="karva-gift__hint">Tipp: Gib im Checkout einfach die Adresse der beschenkten Person als Lieferadresse an.</span>' +
      '</span></span>';
    return box;
  }

  function buildEngraveBox(key, product, title, text) {
    var box = document.createElement('label');
    box.className = 'karva-optimize karva-gift';
    box.id = key + '-box';
    box.innerHTML =
      '<input type="checkbox" id="' + key + '">' +
      '<span style="flex:1 1 auto;min-width:0;"><strong>' + title + ' (+' + euro(product.price) + ')</strong>' +
      '<small>' + text + '</small>' +
      '<span class="karva-gift__fields">' +
        '<input type="text" id="' + key + '-1" maxlength="' + LINE_MAX + '" placeholder="Zeile 1">' +
        '<input type="text" id="' + key + '-2" maxlength="' + LINE_MAX + '" placeholder="Zeile 2 (optional)">' +
      '</span></span>';
    return box;
  }

  function buildEngrave() {
    return buildEngraveBox('karva-engrave', ENGRAVE, 'Gravur auf der Rückseite',
      'Wir fräsen deinen Gruß auf die Rückseite: zwei Zeilen mit je bis zu ' + LINE_MAX + ' Zeichen, z. B. Namen und Datum.');
  }

  function buildFront() {
    return buildEngraveBox('karva-front', FRONT, 'Gravur auf der Vorderseite',
      'Wir fräsen deinen Text dezent auf die Vorderseite: zwei Zeilen mit je bis zu ' + LINE_MAX + ' Zeichen, z. B. Namen und Datum.');
  }

  function buildSocial() {
    var box = document.createElement('label');
    box.className = 'karva-optimize karva-gift karva-social';
    box.id = 'karva-social-box';
    box.innerHTML =
      '<input type="checkbox" id="karva-social">' +
      '<span style="flex:1 1 auto;min-width:0;"><strong>Ihr dürft mich fragen, ob ihr mein Bild zeigen dürft</strong>' +
      '<small>Freiwillig und ohne Einfluss auf deine Bestellung. Nach dem Versand fragen wir dich per E-Mail, ' +
      'ob wir dein fertiges Bild auf Instagram & Co. zeigen dürfen. Ohne dein ausdrückliches Ja zeigen wir nichts.</small>' +
      '</span>';
    return box;
  }

  function socialWanted() { var c = byId('karva-social'); return !!(c && c.checked); }

  function buildExpress() {
    var box = document.createElement('label');
    box.className = 'karva-optimize karva-gift karva-express';
    box.id = 'karva-express-box';
    box.innerHTML =
      '<input type="checkbox" id="karva-express">' +
      '<span style="flex:1 1 auto;min-width:0;"><strong>Express: in 24 Stunden verschickt (+' + euro(EXPRESS.price) + ')</strong>' +
      '<small>Wir fräsen und lackieren dein Bild noch am selben Tag, nach dem Trocknen über Nacht geht es am nächsten Werktag raus.</small>' +
      '<span class="karva-express__when" data-karva-express-text="short"></span>' +
      '<span class="karva-express__ship">Für die Zustellung am Tag danach im Checkout zusätzlich „Expressversand DPD“ wählen.</span>' +
      '</span>';
    return box;
  }

  function refreshExpressTexts() {
    if (!EXPRESS) return;
    var els = document.querySelectorAll('[data-karva-express-text]');
    for (var i = 0; i < els.length; i++) {
      els[i].textContent = expressText(els[i].getAttribute('data-karva-express-text') === 'short');
    }
  }

  function wire(box, cbId) {
    var cb = box.querySelector('#' + cbId);
    cb.addEventListener('change', function () { box.classList.toggle('is-on', cb.checked); });
    // Tastatureingaben in den Textfeldern nicht an Theme-Shortcuts weiterreichen
    var fields = box.querySelectorAll('textarea,input[type=text]');
    for (var i = 0; i < fields.length; i++) {
      fields[i].addEventListener('keydown', stop);
    }
  }

  function anchorEl() {
    var a = byId('karva-mount') || byId('karva-optimize');
    return a ? a.closest('label') : null;
  }

  function place(after, product, id, build) {
    if (product && !byId(id + '-box')) {
      var b = build();
      after.parentNode.insertBefore(b, after.nextSibling);
      wire(b, id);
      return b;
    }
    return byId(id + '-box') || after;
  }

  function insertBoxes() {
    var anchor = anchorEl();
    if (!anchor) return false;
    injectStyles();
    var after = anchor;
    if (EXPRESS && !byId('karva-express-box')) {
      var x = buildExpress();
      after.parentNode.insertBefore(x, after.nextSibling);
      wire(x, 'karva-express');
      if (window.KARVA_EXPRESS_PRESELECT) {
        x.querySelector('#karva-express').checked = true;
        x.classList.add('is-on');
      }
      refreshExpressTexts();
      after = x;
    } else if (byId('karva-express-box')) {
      after = byId('karva-express-box');
    }
    if (GIFT && !byId('karva-gift-box')) {
      var g = buildGift();
      after.parentNode.insertBefore(g, after.nextSibling);
      wire(g, 'karva-gift');
      counter(byId('karva-gift-msg'), byId('karva-gift-msg-count'), MSG_MAX);
      after = g;
    } else if (byId('karva-gift-box')) {
      after = byId('karva-gift-box');
    }
    after = place(after, ENGRAVE, 'karva-engrave', buildEngrave);
    after = place(after, FRONT, 'karva-front', buildFront);
    if (!byId('karva-social-box')) {
      var so = buildSocial();
      after.parentNode.insertBefore(so, after.nextSibling);
    }
    return true;
  }

  function waitAndInsert(tries) {
    // Die Wandhalterung wird asynchron eingefügt; kurz warten, damit die Reihenfolge stimmt
    if (byId('karva-mount') || tries > 25) {
      if (!insertBoxes() && tries < 60) setTimeout(function () { waitAndInsert(tries + 1); }, 300);
      return;
    }
    setTimeout(function () { waitAndInsert(tries + 1); }, 200);
  }

  function expressWanted() { var c = byId('karva-express'); return !!(c && c.checked && EXPRESS); }

  function giftWanted() { var c = byId('karva-gift'); return !!(c && c.checked && GIFT); }

  function linesFor(key, product) {
    var c = byId(key);
    if (!(c && c.checked && product)) return null;
    var l1 = (byId(key + '-1') || {}).value || '';
    var l2 = (byId(key + '-2') || {}).value || '';
    l1 = l1.trim().slice(0, LINE_MAX); l2 = l2.trim().slice(0, LINE_MAX);
    if (!l1 && !l2) return null;
    return [l1, l2];
  }

  (function wrapFetch() {
    var original = window.fetch;
    if (typeof original !== 'function') return;
    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (/\/cart\/add(\.js)?(\?|$)/.test(url) && init && typeof FormData !== 'undefined' &&
            init.body instanceof FormData && init.body.has('properties[_Render-Settings]')) {
          var gift = giftWanted();
          var lines = linesFor('karva-engrave', ENGRAVE);
          var front = linesFor('karva-front', FRONT);
          var express = expressWanted();
          if (socialWanted()) init.body.set('properties[Social-Media]', 'Ja, ihr dürft mich fragen');
          if (gift || lines || front || express) {
            var qty = parseInt(init.body.get('quantity'), 10) || 1;
            var extra = [];
            if (express) {
              var plan = expressPlan();
              init.body.set('properties[Express]', 'Ja – Versand am ' + fmtDay(plan.ship));
              extra.push({ id: EXPRESS.id, quantity: qty, properties: { 'Versand am': fmtDay(plan.ship) } });
            }
            if (gift) {
              init.body.set('properties[Geschenk]', 'Ja, als Geschenk verpacken');
              var msg = ((byId('karva-gift-msg') || {}).value || '').trim().slice(0, MSG_MAX);
              var gp = {};
              if (msg) gp['Grußkarte'] = msg;
              extra.push({ id: GIFT.id, quantity: qty, properties: gp });
            }
            if (lines) {
              var txt = lines.filter(Boolean).join(' / ');
              init.body.set('properties[Gravur Rückseite]', txt);
              extra.push({ id: ENGRAVE.id, quantity: qty, properties: { 'Text': txt } });
            }
            if (front) {
              var ftxt = front.filter(Boolean).join(' / ');
              init.body.set('properties[Gravur Vorderseite]', ftxt);
              extra.push({ id: FRONT.id, quantity: qty, properties: { 'Text': ftxt } });
            }
            var self = this, args = arguments;
            return original.apply(self, args).then(function (res) {
              if (!res || !res.ok) return res;
              return original.call(window, '/cart/add.js', {
                method: 'POST',
                credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ items: extra })
              }).then(function () { return res; }, function () { return res; });
            });
          }
        }
      } catch (e) { /* den Warenkorb nie blockieren */ }
      return original.apply(this, arguments);
    };
  })();

  function init() {
    Promise.all([loadProduct(GIFT_HANDLE), loadProduct(ENGRAVE_HANDLE), loadProduct(EXPRESS_HANDLE), loadProduct(FRONT_HANDLE)]).then(function (r) {
      GIFT = r[0]; ENGRAVE = r[1]; EXPRESS = r[2]; FRONT = r[3];
      if (inBreak()) { EXPRESS = null; showBreakNotice(); }
      initExpressBanner();
      waitAndInsert(0);
      // Konfigurator kann neu aufgebaut werden (Overlay öffnen/schließen) – Boxen ggf. erneut einfügen
      setInterval(function () {
        if (anchorEl() && (!byId('karva-gift-box') && GIFT || !byId('karva-engrave-box') && ENGRAVE || !byId('karva-front-box') && FRONT || !byId('karva-express-box') && EXPRESS || !byId('karva-social-box'))) insertBoxes();
      }, 1500);
      setInterval(refreshExpressTexts, 30000);
    });
  }

  // Banner wird hinter dem Vorschau-Hinweis eingefügt (nur auf Bild-Produktseiten mit Konfigurator)
  function showBreakNotice() {
    var hint = document.querySelector('.karva-preview-hint');
    if (!hint || !byId('start-editing') || document.querySelector('.karva-break-notice')) return;
    var d = new Date(BREAK_END + 'T00:00:00Z');
    var months = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];
    var box = document.createElement('div');
    box.className = 'karva-break-notice';
    box.style.cssText = 'margin:0 0 16px;padding:12px 14px;border:1px solid #c9c3b8;background:#f6f4f0;color:#202020;line-height:1.5;font-size:14px;';
    box.innerHTML = '<strong style="display:block;font-size:15px;">Weihnachtspause in der Werkstatt</strong>' +
      'Neue Bestellungen fertigen wir ab dem ' + d.getUTCDate() + '. ' + months[d.getUTCMonth()] + ' ' + d.getUTCFullYear() +
      '. ' + (berlinNow().date.getUTCMonth() === 11 ? 'Für Weihnachten gibt es unseren ' : 'Als Geschenk gibt es unseren ') +
      '<a href="/pages/gutscheine" style="text-decoration:underline;">Geschenkgutschein</a>, sofort per E-Mail.';
    hint.parentNode.insertBefore(box, hint.nextSibling);
  }

  function createExpressBanner() {
    if (!EXPRESS || document.querySelector('[data-karva-express-banner]')) return;
    var hint = document.querySelector('.karva-preview-hint');
    if (!hint || !byId('start-editing')) return;
    var a = document.createElement('a');
    a.href = '#';
    a.className = 'karva-express-banner';
    a.setAttribute('data-karva-express-banner', '');
    a.style.cssText = 'display:flex;gap:12px;align-items:flex-start;margin:0 0 16px;padding:12px 14px;border:2px solid #DFB773;' +
      'background:#fbf6ec;color:#202020;text-decoration:none;line-height:1.45;';
    a.innerHTML =
      '<svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true" style="flex:0 0 auto;margin-top:1px;">' +
      '<path d="M13 2 4 14h7l-1 8 9-12h-7z" fill="#DFB773" stroke="#202020" stroke-width="1.2" stroke-linejoin="round"/></svg>' +
      '<span style="flex:1 1 auto;min-width:0;">' +
      '<strong style="display:block;font-size:15px;">Express: in 24 Stunden verschickt ' +
      '<span data-karva-express-price style="font-weight:400;"></span></strong>' +
      '<span data-karva-express-text style="display:block;font-size:13.5px;"></span>' +
      '<span style="display:block;font-size:12.5px;opacity:.75;margin-top:2px;">Im Konfigurator „Express“ wählen, ' +
      'im Checkout „Expressversand DPD“ für die Zustellung am Tag danach.</span></span>';
    hint.parentNode.insertBefore(a, hint.nextSibling);
  }

  function initExpressBanner() {
    createExpressBanner();
    var banners = document.querySelectorAll('[data-karva-express-banner]');
    for (var i = 0; i < banners.length; i++) {
      var b = banners[i];
      if (!EXPRESS) { b.style.display = 'none'; continue; }
      var price = b.querySelector('[data-karva-express-price]');
      if (price) price.textContent = '+' + euro(EXPRESS.price);
      b.addEventListener('click', function (e) {
        e.preventDefault();
        window.KARVA_EXPRESS_PRESELECT = true;
        var c = byId('karva-express');
        if (c && !c.checked) { c.checked = true; c.closest('label').classList.add('is-on'); }
        var start = byId('start-editing');
        if (start) start.click();
      });
    }
    refreshExpressTexts();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
